import TabsListView from './views/tabs-list-view'
import Core from '../core'

Core.Tasks.add(Core.Events.PAGE_COMPLETE, () => {
    new TabsListView()
})
